import { toggleNewsFollowApi } from "../../../api/newsFollow.api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useToggleNewsFollow = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: toggleNewsFollowApi,

    onSuccess: (_, id) => {
      queryClient.invalidateQueries({ queryKey: ["news"] });
      queryClient.invalidateQueries({ queryKey: ["news", id] });
    },
  });
};
